"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const module_abstract_1 = require("./module/module.abstract");
const canvas_1 = require("./canvas/canvas");
const layout_1 = require("./layout/layout");
class App extends module_abstract_1.Module {
    static _instance = new App();
    static get instance() {
        return this._instance;
    }
    constructor() {
        super([
            new canvas_1.Canvas(),
            new layout_1.Layout(),
        ]);
    }
    get canvas() {
        return this.getSubmodule(canvas_1.Canvas);
    }
}
exports.App = App;
